var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleManagementIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.16406H11.9344C14.9816 5.16406 16.5053 5.16406 17.0836 5.71135C17.5836 6.18443 17.8051 6.88134 17.6702 7.55627C17.514 8.33708 16.2701 9.21692 13.7823 10.9766L9.71772 13.8515C7.2299 15.6112 5.98599 16.491 5.82984 17.2719C5.69486 17.9468 5.91642 18.6437 6.41636 19.1168C6.99474 19.6641 8.51836 19.6641 11.5656 19.6641H12.5M8 5.16406C8 6.82092 6.65685 8.16406 5 8.16406C3.34315 8.16406 2 6.82092 2 5.16406C2 3.50721 3.34315 2.16406 5 2.16406C6.65685 2.16406 8 3.50721 8 5.16406ZM22 19.1641C22 20.8209 20.6569 22.1641 19 22.1641C17.3431 22.1641 16 20.8209 16 19.1641C16 17.5072 17.3431 16.1641 19 16.1641C20.6569 16.1641 22 17.5072 22 19.1641Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleManagementIcon);
export default __webpack_public_path__ + "static/media/ScheduleManagementIcon.ee309ce032e5e01a11dd3b7ca3e35b64.svg";
export { ForwardRef as ReactComponent };